import Fab from "@material-ui/core/Fab"
import { createStyles, makeStyles } from "@material-ui/core/styles"
import React, { PropsWithChildren } from "react"

export type CircleContactButtonProps = PropsWithChildren<{
  href: string
  color?: string
  background?: string
}>

const useStyles = makeStyles(() => createStyles({
  root: {},
}))

export default function CircleContactButton(props: CircleContactButtonProps) {
  const {
    color = '#ffffff',
    background,
    children,
    ...restProps
  } = props

  const classes = useStyles()

  return (
    <Fab
      className={classes.root}
      target="_blank"
      size='small'
      variant='extended'
      style={{background, backgroundColor: color}}
      {...restProps}
    >
      {children}
    </Fab>
  )
}
